import React from 'react';

// eslint-disable-next-line import/prefer-default-export
export function CrossIcon() {
	return (
  <svg
    viewBox="0 0 30 30"
    width="22px"
    height="22px"
    display="block"
    fill="inherit"
    flex-shrink="0"
    backface-visibility="hidden"
  >
    <polygon points="26,5.4 24.6,4 15,13.6 5.4,4 4,5.4 13.6,15 4,24.6 5.4,26 15,16.4 24.6,26 26,24.6 16.4,15 " />
  </svg>
  );
}